var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1,
    d: "M10.5,6.5 L4.5,6.5 C3.396,6.5 2.5,7.396 2.5,8.5 L2.5,17.5 C2.5,18.604 3.396,19.5 4.5,19.5 L19.5,19.5 C20.604,19.5 21.5,18.604 21.5,17.5 L21.5,8.5 C21.5,7.396 20.604,6.5 19.5,6.5 L13.5,6.5 M10.5,7.5 L10.5,5 C10.5,4.171 11.171,3.5 12,3.5 C12.829,3.5 13.5,4.171 13.5,5 L13.5,7.5 L10.5,7.5 Z M13,12.5 L17,12.5 M13,14.5 L19,14.5 M8.5,10.5 C9.604,10.5 10.5,11.619 10.5,13 C10.5,14.381 9.604,15.5 8.5,15.5 C7.396,15.5 6.5,14.381 6.5,13 C6.5,11.619 7.396,10.5 8.5,10.5 Z M9.854,14.8301 C11.286,15.5391 12.328,17.3391 12.471,19.5001 M4.5,19.5 L4.529,19.5 C4.672,17.339 5.714,15.539 7.146,14.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.f358d2914846ae0603c8947174ee7585.svg";
export { ForwardRef as ReactComponent };